@if (!isEditing()) {
  <a class="list-group-item list-group-item-action py-3"
     [class.active]="isSelected()">
    {{ group().displayName }}
  </a>
} @else {
  <a class="list-group-item align-items-center py-3">
    <span class="flex-grow-1">
      {{ group().displayName }}
    </span>

    <button type="button"
            class="btn btn-sm btn-outline-danger border-0"
            [routerLink]="['./']"
            (click)="delete(group())">
      <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
    </button>
  </a>
}